import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import connectionPointService from '../services/ConnectionPoint'
import { parseConnectionPoints } from '../utility/parseConnectionPoints'

export const connectionPointsTableSlice = createSlice({
    name: 'connectionPointsTable',
    initialState: {
        loading: false,
        connectionPoints: [],
        totalRows: 0,
        currentPage: 0
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setConnectionPoints: (state, action) => {
            state.connectionPoints = action.payload
        },
        setTotalRows: (state, action) => {
            state.totalRows = action.payload
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(loadConnectionPoints.fulfilled, (state, action) => {
            const { connectionPoints, totalRows, currentPage } = action.payload
            state.connectionPoints = connectionPoints
            state.totalRows = totalRows
            state.currentPage = currentPage
            state.loading = false
        })
    }
})

export const loadConnectionPoints = createAsyncThunk('connectionPoints/load', async (filters) => {
    const {
        data: {
            data: { total, current_page, data: connectionPoints }
        }
    } = await connectionPointService.getConnectionPoints(filters)

    return {
        connectionPoints: parseConnectionPoints(connectionPoints),
        totalRows: total,
        currentPage: current_page
    }
})

export const { setLoading, setConnectionPoints, setTotalRows, setValuePerPage, setCurrentPage } =
    connectionPointsTableSlice.actions
export default connectionPointsTableSlice.reducer
